import { Inject, InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';

export * from './meta-reducers';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface AppState {}

/**
 * Combine default and application specyfic reducers. Use {@link APP_REDUCERS} token
 * to add reducers.
 */
export function getReducers(appReducers: Partial<ActionReducerMap<AppState>>) {
  return {
    ...appReducers,
  };
}
/**
 * Application specific reducers.
 */
export const APP_REDUCERS = new InjectionToken<
  ActionReducerMap<Partial<AppState>>
>('APP_REDUCERS');

export const REDUCERS = new InjectionToken<ActionReducerMap<Partial<AppState>>>(
  'REDUCERS'
);

/**
 * Sets up base store providers.
 */
export const STORE_PROVIDERS = [
  {
    provide: APP_REDUCERS,
    useValue: {},
  },
  {
    provide: REDUCERS,
    useFactory: getReducers,
    deps: [[new Inject(APP_REDUCERS)]],
  },
];
